export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["To access all features of your account, please complete a quick identity verification. This helps us keep your account secure and comply with financial regulations."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Get Verified Now"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Later"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Verify your identity"])}
}